<template>
  <div>

    <b-modal ref="myModalRef" hide-footer centered>

      <div centered slot="modal-title">
        {{$t('edit.deleteSIP')}}
      </div>

      <div class="d-block text-center">

        <div v-if="deleteSIPError" class="alert alert-danger">{{$t('anErrorOccurred')}}</div>

        {{$t('edit.areYouSureDelete')}}
        <b>{{ sipName }}</b>
      </div>

      <b-button-group size="lg" class="mt25">
        <b-button size="lg" class="custom-bgr-danger" variant="danger" @click="hideModalDeleteSIP()">{{$t('edit.cancel')}}</b-button>
        <b-button size="lg" class="custom-bgr-primary" variant="primary" @click="deleteSip()">{{$t('editSIP.delete')}}</b-button>
    </b-button-group>

    </b-modal>


    <!--<base-header></base-header>-->
    <div class="container">
      <div class="form-header">{{$t('editSIP.header')}}</div>
      <div class="form-group">
        <input type="text" class="form-control" v-model="username" :placeholder="$t('editSIP.username')" :class="{'form-error': errorMessage['username']}" autocomplete="off" disabled="disabled" />
        <p v-for="msg in errorMessage['username']" class="text-error">{{msg}}</p>
      </div>
      <div class="form-group">
        <input type="password" class="form-control" v-model="password" :placeholder="$t('editSIP.password')" :class="{'form-error': errorMessage['password']}" autocomplete="new-password" disabled="disabled" />
        <p v-for="msg in errorMessage['password']" class="text-error">{{msg}}</p>
      </div>
      <div class="form-group">
        <input type="text" class="form-control" v-model="domain" :placeholder="$t('editSIP.domain')" :class="{'form-error': errorMessage['domain']}" autocomplete="off" disabled="disabled" />
        <p v-for="msg in errorMessage['domain']" class="text-error">{{msg}}</p>
      </div>
      <div class="form-group text-center btn-submit">
        <div class="row">
          <div class="col-xs-4">
              <base-button type="button" class="btn-block btn-default" @click="goBack()">{{$t('edit.cancel')}}</base-button>
          </div>

          <div class="col-xs-4">
            <base-button type="button" class="btn-block btn-danger" :disabled="isActive == 1 || isActive === 1 || created_by == 'SYSTEM'" @click="showModalDeleteSIP()">{{$t('editSIP.delete')}}</base-button>
          </div>

          <div class="col-xs-4">
            <router-link :to="{name: 'EditSipPage', params: {id}}">
              <base-button type="button" class="btn-block btn-info" :disabled="created_by == 'SYSTEM'">{{$t('editSIP.edit')}}</base-button>
            </router-link>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Slide from '../components/Slide';
  import BaseButton from "../components/Button.vue";
  import BaseHeader from "../components/Header.vue";
  import i18n from '../languages/i18n';

  import Vue from 'vue'
  import BootstrapVue from 'bootstrap-vue'
  import bModal from 'bootstrap-vue/es/components/modal/modal'
  import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
  import bButton from 'bootstrap-vue/es/components/button/button';
  import bButtonGroup from 'bootstrap-vue/es/components/button-group/button-group';
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap-vue/dist/bootstrap-vue.css'

  Vue.component('b-modal', bModal);
  Vue.directive('b-modal', bModalDirective);
  Vue.component('b-button', bButton);
  Vue.component('b-button-group', bButtonGroup);

  export default {
    components: {
      BaseHeader,
      BaseButton,
      Slide,
    },
    name: 'EditSipInfoPage',
    props: {
      id: [Number, String],
    },
    data() {
      return {
        username: '',
        password: '',
        domain: '',
        errorMessage: [],
        isActive: 1,
        created_by: '',
        sipName: '',
        deleteSIPError: false
      };
    },
    methods: {
      showModalDeleteSIP () {
        this.sipName = this.username + '@' + this.domain;
        this.$refs.myModalRef.show()
      },
      hideModalDeleteSIP () {
        this.$refs.myModalRef.hide()
      },
      deleteSip() {
        const token = localStorage.getItem('token');
        this.axios.post('/delete/' + this.id + '?token=' + token).then((response) => {
          if (response.data.status) {
            this.deleteSIPError = false;
            this.$router.push({name: 'EditPage', params: {sip_delete: response.data.delete}});
          } else {
            this.deleteSIPError = true;
            this.errorMessage = response.data.data;
          }
        })
      },
      activeSip() {
        const token = localStorage.getItem('token');
        this.axios.post('/active/' + this.id + '?token=' + token).then((response) => {
          top.window.location.href = response.data.data.url;
        })
      },
      goBack() {
        if (window.history.length > 0) {
          window.history.back();
        } else {
          this.$router.push({name: 'EditPage'});
        }
      }
    },
    mounted() {
      const token = localStorage.getItem('token');
      if (!token) {
        this.$router.push({name: 'LoginPage'});
      }
      this.axios.get('/sipInfo/' + this.id + '?token=' + token).then(response => {
        if (response.data.status) {
          this.username = response.data.data.sip_username;
          this.password = response.data.data.sip_password;
          this.isActive = response.data.data.status;
          this.domain = response.data.data.sip_domain;
          this.created_by = response.data.data.created_by;
        } else {
          this.$router.push({name: 'EditPage'});
        }
      })
    }
  };
</script>
<style scoped="">
</style>



// WEBPACK FOOTER //
// src/pages/EditSipInfoPage.vue